// import { BIG_ZERO } from 'utils/bigNumber'
import { Text, useMatchBreakpoints } from "@pancakeswap/uikit";
import BigNumber from "bignumber.js";
import { BIG_ZERO } from "utils/bigNumber";
import BaseCell, { CellContent } from "views/Pools/components/PoolsTable/Cells/BaseCell";
import FarmApr from "../../FarmApr";
import styled from "styled-components";

interface FarmAprCellProps {
  pool: any;
  index : any;
}
const StyledCell = styled(BaseCell)`
  width:200px;
`
const FarmAprCell: React.FC<FarmAprCellProps> = ({ pool,index }) => {
  // const { t } = useTranslation()
  const { isMobile } = useMatchBreakpoints();
  const { userData } = pool;
  const stakedBalance = userData?.stakedBalance
    ? new BigNumber(userData.stakedBalance)
    : BIG_ZERO;

  return (
    <BaseCell
      role="cell"
      width={["100px", "150px", "150px", "150px", "250px"]}
      // flex={["1 0 50px", "1 0 50px", "2 0 100px", "2 0 100px", "1 0 20px"]}
    // flex={"1 0 10px"}

    >
      <StyledCell role="cell">
        <CellContent>
          <Text fontSize="12px" color="#00FED9" textAlign="left">
            APR
          </Text>
          <FarmApr pool={pool} index={index} stakedBalance={stakedBalance} showIcon={!isMobile} />
        </CellContent>
      </StyledCell>
    </BaseCell>
  );
};

export default FarmAprCell;
